import React from "react";
import { Link } from "react-router-dom";
import { useI18n, lifeAreaLabels } from "@/lib/i18n";
import {
  HeartPulse, Users, Home, Wallet, FileText, Shield, Monitor, ScrollText, Sparkles,
} from "lucide-react";

const ICONS = {
  "heart-pulse": HeartPulse,
  users: Users,
  home: Home,
  wallet: Wallet,
  "file-text": FileText,
  shield: Shield,
  monitor: Monitor,
  scroll: ScrollText,
  sparkles: Sparkles,
};

const STATUS_TONE = {
  alles_geregelt: { dot: "bg-emerald-500", text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-200" },
  teilweise_geregelt: { dot: "bg-amber-500", text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-200" },
  handlungsbedarf: { dot: "bg-slate-700", text: "text-slate-700", bg: "bg-slate-50", border: "border-slate-200" },
};

export default function LifeAreaCard({ area, compact = false }) {
  const { t, lang } = useI18n();
  const Icon = ICONS[area.icon] || Sparkles;
  const tone = STATUS_TONE[area.status] || STATUS_TONE.handlungsbedarf;
  const labels = lifeAreaLabels[lang] || lifeAreaLabels.de;

  return (
    <Link
      to={`/lebensbaum#${area.category}`}
      data-testid={`life-area-${area.category}`}
      className="ag-card ag-card-hover block p-6 group"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="h-11 w-11 rounded-xl bg-slate-100 group-hover:bg-slate-900 group-hover:text-white flex items-center justify-center transition-colors">
          <Icon className="h-5 w-5" strokeWidth={1.5} />
        </div>
        <span className={`ag-badge ${tone.bg} ${tone.text} ${tone.border} border`}>
          <span className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} />
          {t.statuses[area.status]}
        </span>
      </div>

      <div className="font-serif text-2xl text-ag-ink leading-tight mb-1">{labels[area.category] || area.name}</div>
      {!compact && (
        <div className="text-xs text-slate-500 mb-4 line-clamp-1">
          {(area.subitems || []).slice(0, 3).join(" · ")}
        </div>
      )}

      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-wider text-slate-400">Fortschritt</div>
          <div className="font-serif text-3xl text-ag-ink tabular-nums">{area.progress}%</div>
        </div>
        <div className="w-1/2">
          <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden">
            <div
              className="h-full rounded-full transition-all"
              style={{ width: `${area.progress || 0}%`, backgroundColor: area.status === "alles_geregelt" ? "#10B981" : area.status === "teilweise_geregelt" ? "#F59E0B" : "#0F172A" }}
            />
          </div>
        </div>
      </div>
    </Link>
  );
}
